import { render, staticRenderFns } from "./popup-record-shou-kuan.vue?vue&type=template&id=45b7cf10&scoped=true"
import script from "./popup-record-shou-kuan.vue?vue&type=script&lang=js"
export * from "./popup-record-shou-kuan.vue?vue&type=script&lang=js"
import style0 from "./popup-record-shou-kuan.vue?vue&type=style&index=0&id=45b7cf10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7cf10",
  null
  
)

export default component.exports